<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>
          <a @click="$functions.historyBack()" style="cursor: pointer">{{$t('factory.title')}}</a>
          <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> 
          {{$t('factory.appliances.title')}}
        </h2>
        <div class="irinox-form factory-form" >
          <TabView>
            <TabPanel :header="$t('factory.tab_appliances')">
              <Appliances :email="email" :role="role"/>
            </TabPanel>
          </TabView>
        </div>
		</div>
	</div>

</template>

<script>
import Appliances from './Appliances.vue';
export default {
  
    components: {
      Appliances
    },
    data() {
        return {
          encryptedEmailRole: this.$route.params.encryptedEmailRole
        };
    },
    computed: {
      decryptedEmailRole() {
        return this.$functions.decrypt("factory", this.encryptedEmailRole).split("|||");
      },
      email() {
        return this.decryptedEmailRole[0];
      },
      role() {
        return this.decryptedEmailRole[1];
      }
    },
    created() {
      if(this.decryptedEmailRole.length!=2) {
        this.$router.push({ name: 'factory' });
      }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style>

</style>